_ = require('underscore')

unless _.isFunction(window.requestAnimationFrame)
  window.requestAnimationFrame or= window.webkitRequestAnimationFrame
  window.requestAnimationFrame or= window.mozRequestAnimationFrame
  window.requestAnimationFrame or= window.oRequestAnimationFrame
  window.requestAnimationFrame or= window.msRequestAnimationFrame
  window.requestAnimationFrame or= (callback) -> window.setTimeout(callback, 1000/60)

module.exports = window.requestAnimationFrame


// WEBPACK FOOTER //
// ./assets/js/shared/util/request_animation_frame_polyfill.coffee